import React from "react";
import { Card, List, Space, Typography } from "antd";

export type MobileCardField = {
  label: string;
  value: React.ReactNode;
};

type Props<T> = {
  items: T[];
  rowKey: (item: T) => string;
  title: (item: T) => React.ReactNode;
  fields?: (item: T) => MobileCardField[];
  actions?: (item: T) => React.ReactNode;
  description?: (item: T) => React.ReactNode;
  testId?: string;
  empty?: React.ReactNode;
};

/**
 * Card list used below the md breakpoint instead of Ant Design Table (US-901 / US-902).
 */
export function MobileDataCards<T>({
  items,
  rowKey,
  title,
  fields,
  actions,
  description,
  testId = "mobile-data-cards",
  empty,
}: Props<T>) {
  if (items.length === 0) {
    return <>{empty ?? null}</>;
  }

  return (
    <List
      data-testid={testId}
      className="mobile-data-cards"
      grid={{ gutter: 12, column: 1 }}
      dataSource={items}
      renderItem={(item) => {
        const fieldRows = fields?.(item) ?? [];
        return (
          <List.Item key={rowKey(item)} style={{ padding: 0, marginBottom: 12 }}>
            <Card
              size="small"
              className="mobile-data-card"
              title={title(item)}
              extra={actions ? <div className="mobile-data-card__actions">{actions(item)}</div> : undefined}
            >
              {description?.(item)}
              {fieldRows.length > 0 && (
                <Space direction="vertical" size={6} style={{ width: "100%" }}>
                  {fieldRows.map((f) => (
                    <div key={f.label} className="mobile-data-card__field">
                      <Typography.Text type="secondary" className="mobile-data-card__label">
                        {f.label}
                      </Typography.Text>
                      <div className="mobile-data-card__value">{f.value}</div>
                    </div>
                  ))}
                </Space>
              )}
            </Card>
          </List.Item>
        );
      }}
    />
  );
}
